import React from "react";
import { Button } from "react-bootstrap";
import { TiMinus } from "react-icons/ti";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { getTabIdx } from "../../../../redux/selectors";
import { getItemData, getItemQty } from "../../../../redux/selectors/showRooms";
import { substractItemQty } from "../../../../redux/features/showRooms/showRoomsSlice";

const Minus = ({ tabID, mtrl, row }) => {
  const dispatch = useDispatch();
  const idx = useSelector((state) => getTabIdx(state, tabID));
  const itemQty = useSelector((state) => getItemQty(state, idx, mtrl));
  const itemData = useSelector((state) => getItemData(state, idx, tabID));

  const handleSubstractQty = () => {
    var data = {};
    if (!itemData) {
      Object.keys(row).map((key) => {
        if (key != "FLD-1" && key.startsWith("ITEM_") && !key.startsWith("ITEM_MTRL_")) {
          const newKey = `MTRL_${key}`;
          data[newKey] = row[key];
        } else if (key.startsWith("ITEM_MTRL_")) {
          data[key.slice(5)] = row[key];
        }
      });
      data.MTRL = mtrl;
    } else {
      data = itemData;
    }

    dispatch(substractItemQty({ idx, mtrl, data, row }));
  };
  return (
    <Button disabled={itemQty == 0} variant="secondary" onClick={handleSubstractQty}>
      <TiMinus />
    </Button>
  );
};

export default Minus;
